<div class="container noselect">
  <div class="row justify-content-center">
    <div id="ajax-load-calendar" class="calendar">
      <div class="calendar-box">
        <div class="calendar-header">
          <h3>
            <a *ngIf="canBackwardMonth">
              <fa-icon class="touch-area" [icon]="faCaretLeft" (click)="shiftMonth(-1)"></fa-icon>
            </a>
            <span class="touch-area" *ngIf="!canBackwardMonth">&nbsp;</span>
            <span class="month">{{ monthName }}
              <span *ngIf="showYear" class="infotext"> {{ calendarYear }}</span>
            </span>
            <a>
              <fa-icon class="touch-area" [icon]="faCaretRight" (click)="shiftMonth(1)"></fa-icon>
            </a>
          </h3>
        </div>
        <div class="calendar-body">
          <div class="row weekdays d-flex justify-content-start align-content-stretch align-items-end">
            <div *ngFor="let dayOfWeek of daysOfWeek" class="col">{{ dayOfWeek }}.</div>
          </div>
          <div class="calendar-content">
            <div *ngFor="let calendarRow of calendarTable" class="row dates">
              <div *ngFor="let day of calendarRow" (click)='onSelectDate(day)' [ngClass]="{
                      'slots-date-selected': isSelected(day),
                      'inactive': day.disabled,
                      'slots-date':!day.disabled,
                      'today' : isToday(day),
                      'other-month' : !isThisMonth(day)
                    }" class="col">{{day.date}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
